(() => {
  const phoneNumber = '8801751812347';
  const isMobile =
    typeof navigator.userAgentData?.mobile === 'boolean'
      ? navigator.userAgentData.mobile
      : /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const getWhatsAppLink = (eventPath) =>
    eventPath.find((element) => {
      if (!(element instanceof HTMLAnchorElement)) return false;
      return element.hostname === 'wa.me' || element.hostname === 'web.whatsapp.com';
    });

  const buildDestination = (link) => {
    const source = new URL(link.href);
    const message = source.searchParams.get('text');
    const destination = isMobile
      ? new URL(`https://wa.me/${phoneNumber}`)
      : new URL('https://web.whatsapp.com/send');

    if (!isMobile) destination.searchParams.set('phone', phoneNumber);
    if (message) destination.searchParams.set('text', message);
    return destination;
  };

  const correctVisibleLinks = () => {
    document
      .querySelectorAll('a[href*="wa.me"], a[href*="web.whatsapp.com/send"]')
      .forEach((link) => {
        if (!(link instanceof HTMLAnchorElement)) return;
        link.href = buildDestination(link).toString();
      });
  };

  document.addEventListener(
    'click',
    (event) => {
      const eventPath =
        typeof event.composedPath === 'function' ? event.composedPath() : [];
      const link = getWhatsAppLink(eventPath);
      if (!link) return;

      const destination = buildDestination(link);
      event.preventDefault();
      event.stopImmediatePropagation();
      window.open(destination.toString(), '_blank', 'noopener,noreferrer');
    },
    true,
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', correctVisibleLinks, { once: true });
  } else {
    correctVisibleLinks();
  }

  new MutationObserver(correctVisibleLinks).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
